module.exports = __webpack_public_path__ + "img/download-file-xlsx.c7de67ab.svg";